import React from 'react';
import { Link } from 'react-router-dom';

// Minimal chrome for the Quick Play / Play With Friends funnel pages, in the
// game's own design language. The marketing site (landing-page/) owns the
// real landing chrome; the retired React landing shell must not be used here.
function QuickplayShell({ children }) {
    return (
        <div className="play-funnel">
            <header className="play-funnel-header">
                <Link to="/" className="logo icon-logo-beta" aria-label="Nova home" />
            </header>
            <main className="play-funnel-content">{children}</main>
        </div>
    );
}

export { QuickplayShell };
